export default ({color, size}) =>
  <svg t="1729850294478" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       p-id="3210" width={size} height={size}>
    <path
      d="M512 86.4a429.44 429.44 0 0 0-286.4 108.48V112a41.6 41.6 0 0 0-83.2 0v192a41.6 41.6 0 0 0 41.6 41.6h192a41.6 41.6 0 0 0 0-83.2H275.2A346.56 346.56 0 0 1 512 169.6a352 352 0 1 1-350.4 352 41.6 41.6 0 0 0-83.2 0A433.6 433.6 0 1 0 512 86.4z"
      p-id="3211" fill={color}></path>
  </svg>
;
